<template>
  <div>
    <WorkspaceBase :child-component="childComponent" :page="page" :meta="meta" />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  fixed: true,
  disableDefaultMargin: true,
  disableFooter: true,
})

const { getPageAndCache } = usePage()
const { page, meta } = await getPageAndCache()
useHead(meta)

const childComponent = defineAsyncComponent(
  () => import('@/components/workspace/WorkspaceEditor.vue')
)
</script>

<style lang="scss" scoped></style>
